var HashMap = require("../collections/hashMap.js");
var HashSet = require("../collections/hashSet.js");
var List = require("../collections/list.js");
var stringHash = require("../hash.js").stringHash;
var TreeEvent = require("../observable/tree/treeEvent.js");
var InstanceBuilder = require("./instanceBuilder/instanceBuilder.js");

var invClassMap = new HashMap();

// Root extension to jsonify and dejsonify the root
var JsonParser = {  // TODO: better name?
    DEBUG: true,

    getClassMap: function() {
        return invClassMap;
    },

    initJsonParser: function(){
        console.assert(this.hasGlobalUid, "JsonParser requires all nodes to have unique id's");

        this.onAdd("__JsonParser", function(node){
            // TODO: check / remove if some node contains references to other roots
        });

        this.onRemove("__JsonParser", function(node){
            if (!(this.isLocked && this.isLocked()))   // only remove referrers when root is not locked TODO: not clean this relies on undoable!
                node.removeFromReferrers(); // TODO: maybe only remove from referrers except own tree, test this
        });

        this.hasJsonParser = true;
    },

    registerClass: function(constructor, className){
        console.assert(constructor.$class === undefined, "This class is already registered before");
        console.assert(!invClassMap.contains(className), "Another class is already registered with given class-name: " + className);

        constructor.$class = className;
        invClassMap.put(className, constructor);
    },

    jsonify: function(val){
        if (val !== undefined) return this.jsonifyValue(val, true);
        else return this.jsonifyNode(this.data);
    },

    jsonifyValue: function(val, owner){
        if (val == null) return val;
        if (owner){
            if (val.isObservableTreeNode) return this.jsonifyNode(val);
            else if (typeof val != "object") return val;
            else if (val.$class) {
                return val;
            }
            else if (val.getData){  // TODO: get rid of these special objects, maybe make an exception static objects like coord
                if (!val.constructor.$class) throw new Error("Jsonify Error: cannot jsonify object of unregistered class");
                var json = val.getData();
                json["$class"] = val.constructor.$class;
                return json;
            } else throw new Error("Jsonify Error: cannot jsonify general js object");
        } else {
            if (val.isObservableTreeNode){
                if (val.root == this) return {"$idref": val.$id};
                else {
                    if (val.root.getId == undefined) throw new Error("Jsonify Error: cannot jsonify reference to a node in another root without an asset id");
                    return {"$asset": val.root.getId(), "$idref": val.$id};
                }
            } else return val;
        }
    },

    jsonifyNode: function(node){
        var self = this;
        if (!node.constructor.$class) throw new Error("Jsonify Error: cannot jsonify tree node of unregistered class");
        var json = {
            "$id": node.$id,
            "$class": node.constructor.$class
        };

        node.collections.forEach(function(name, col){
            var owner = col.isOwner();
            switch (col.getType()){
                case 'value':
                    json[name] = self.jsonifyValue(col(), owner);
                    break;
                case 'map':
                    json[name] = {};
                    col.forEach(function(key, val){
                        json[name][self.getKeyHash(key)] = [self.jsonifyValue(key, false), self.jsonifyValue(val, owner)]
                    });
                    break;
                case 'set':
                    json[name] = {};
                    col.forEach(function(val){
                        json[name][self.getKeyHash(val)] = self.jsonifyValue(val, owner);
                    });
                    break;
                case 'list':
                    json[name] = [];
                    col.forEach(function(idx, val){
                        json[name][idx] = self.jsonifyValue(val, owner);
                    });
                    break;
            }
        });

        return json;
    },

    getKeyHash: function(key){// TODO: maybe always hash entire jsonified key (note list idx cannot be hashed!), also make sure key 3 and "3" are not mixed up!
        if (key.isObservableTreeNode){
            return key.$id.indexOf("/") != -1 ? stringHash(key.$id) : key.$id;
        } else {
            if (typeof key === 'string') return 's_' + key; // TODO: maybe use stringHash to shorten string when necessary
            if (typeof key === 'number') return 'n_' + key;
            if (typeof key === 'boolean') return 'b_' + key;
        }
    },

    jsonifyPath: function(path){
        var jsonPath = [];
        for (var i = 0; i < path.length; i++){
            jsonPath.push(path[i].collection.getName());
            switch(path[i].collection.getType()){
                case 'map': jsonPath.push(this.getKeyHash(path[i].key), 1); break;
                case 'set': jsonPath.push(this.getKeyHash(path[i].key));    break;
                case 'list': jsonPath.push(path[i].key); break;
            }
        }
        return jsonPath
    },

    findByPath: function(path){ // TODO: needs refactoring! should this be the inverse of jsonifyPath?!
        var result = this.data;
        for (var i = 0; i < path.length; i++){
            if (result.isObservableTreeNode) {
                result = result.collections.get(path[i]);
                if (result.getType() == "value" && i !== path.length-1) result = result();
            }
            else result = result.get(path[i]);
        }
        return result;
    },

    dejsonify: function(json, nodesToSkip) { // Warning: After dejsonifying a node in this root, node SHOULD be added somewhere in the dataTree of this root: otherwise possible memory leaks
        if(!nodesToSkip) nodesToSkip = [];
        if (json && json["$idref"]) return this.findNode(json);
        else if (json && json["$id"]) {
            var node = this.nodeMap.get(json["$id"]); // check if node doesn't already exist
            if (!node){
                node = this.dejsonifyNode(json, nodesToSkip);
                this.resolveReferences(node, nodesToSkip);
            } // TODO: if node already exist: check if json corresponds to found node!
            return node;
        } else return this.dejsonifyValue(json);
    },

    dejsonifyValue: function(json, nodesToSkip){
        if (json == null) return json;
        else if (json["$id"] != undefined) return this.dejsonifyNode(json, nodesToSkip);
        else if (typeof json != "object") return json;
        else if (json['$class'] != undefined) {
            var Constructor = invClassMap.get(json["$class"]);
            if (!Constructor) throw new Error("Dejsonify Error: cannot dejsonify object of unregistered class: " + json["$class"]);
            var value = new Constructor();
            value.setData(json);
            return value;
        }
        else throw new Error("Dejsonify Error: cannot dejsonify general js object");
    },

    _dejsonifyAssert: function(condition, message) {
        if(this.DEBUG){
            if(!condition)
                console.error(message);
        } else {
            if(!condition)
                throw new Error(message);
        }
    },

    dejsonifyNode: function(json, nodesToSkip){
        var self = this;
        var Constructor = invClassMap.get(json["$class"]);
        if (!Constructor) throw new Error("Dejsonify Error: cannot dejsonify object of unregistered class: " + json["$class"]);

        var node = new Constructor(); // TODO: find a good way to maybe let the constructor know it is dejsonifying
        this.registerNode(node, json["$id"]);

        node.collections.forEach(function(name, col){
            var valRes;
            self._dejsonifyAssert(json.hasOwnProperty(name), "A field in the datamodel is not specified in the json: "+name);
            if (col.isOwner()){ // First rebuild the whole data tree, don't resolve node references at this stage
                switch (col.getType()){
                    case 'value':
                        if(nodesToSkip.indexOf(name) != -1) valRes = col(json[name]);
                        else valRes = col(self.dejsonifyValue(json[name], nodesToSkip));
                        self._dejsonifyAssert(valRes, "Validation failed during setting of collection: "+name);
                        break;
                    case 'map':
                        for (var keyHash in json[name]){
                            var key = json[name][keyHash][0];   // TODO: fix situation when key is a node reference while map is owner
                            if(nodesToSkip.indexOf(name) != -1) var val = json[name][keyHash][1];
                            else var val = self.dejsonifyValue(json[name][keyHash][1], nodesToSkip);
                            valRes = col.put(key, val);
                            self._dejsonifyAssert(valRes, "Validation failed during setting of collection: "+name);
                        }
                        break;
                    case 'set':
                        for (var keyHash in json[name]){
                            if(nodesToSkip.indexOf(name) != -1) valRes = col.add(json[name][keyHash]);
                            else valRes = col.add(self.dejsonifyValue(json[name][keyHash], nodesToSkip));
                            self._dejsonifyAssert(valRes, "Validation failed during setting of collection: "+name);
                        }
                        break;
                    case 'list':
                        for (var idx in json[name]){
                            if(nodesToSkip.indexOf(name) != -1) valRes = col.add(idx, json[name][idx]);
                            else valRes = col.add(idx, self.dejsonifyValue(json[name][idx], nodesToSkip));
                            self._dejsonifyAssert(valRes, "Validation failed during setting of collection: "+name);
                        }
                        break;
                }
            }
            else col._json = json[name]; // temp bind unresolved reference json
        });

        Object.keys(json).forEach(function(name){
            self._dejsonifyAssert(name == "$id" || name == "$class"
                || node.collections.contains(name), "A field in the json does not exist in the datamodel: "+name);
        });
        return node;
    },

    resolveReferences: function(node, nodesToSkip){
        var self = this;
        node.collections.forEach(function(name, col){
            var valRes;
            if (!col.isOwner()){
                try {
                    switch (col.getType()){
                        case 'value':
                            if(nodesToSkip.indexOf(name) != -1) valRes = col(col._json);
                            else valRes = col(self.findNode(col._json));
                            console.assert(valRes, "Validation failed during setting of collection: "+name);
                            break;
                        case 'map':
                            for (var keyHash in col._json){
                                var key = col._json[keyHash][0];
                                if (typeof key == "object") key = self.findNode(key);
                                if(nodesToSkip.indexOf(name) != -1) var val = col._json[keyHash][1];
                                else var val = self.findNode(col._json[keyHash][1]);
                                valRes = col.put(key, val);
                                console.assert(valRes, "Validation failed during setting of collection: "+name);
                            }
                            break;
                        case 'set':
                            for (var keyHash in col._json){
                                if(nodesToSkip.indexOf(name) != -1) valRes = col.add(col._json[keyHash]);
                                else valRes = col.add(self.findNode(col._json[keyHash]));
                                console.assert(valRes, "Validation failed during setting of collection: "+name);
                            }
                            break;
                        case 'list':
                            for (var idx in col._json){
                                if(nodesToSkip.indexOf(name) != -1) valRes = col.add(idx, col._json[idx]);
                                else valRes = col.add(idx, self.findNode(col._json[idx]));
                                console.assert(valRes, "Validation failed during setting of collection: "+name);
                            }
                            break;
                    }
                } catch(e) {
                    console.error(e);
                    throw new Error(`Cannot resolve all references in collection "${name}" of object of class "${node.constructor.$class}"`);
                }
                delete col._json;
            }
        });

        node.forEachChild(function(val){
            if (val && val.isObservableTreeNode) self.resolveReferences(val, nodesToSkip);
        });

        if (node instanceof InstanceBuilder) this.registerInstances(node);
    },

    findNode: function(json){
        if (json == null) return null;
        if (json["$asset"]){
            var descriptionRoot = this.dataLoader.getDescriptionRoot(json["$asset"]); // TODO: this process should become async
            var res = descriptionRoot.nodeMap.get(json['$idref']);
            if(!res) throw new Error("Object not found with idref: "+json['$idref']);
            return res;
        } else {
            var node = this.nodeMap.get(json["$idref"]);
            if (node) return node;
            else {
                var instanceBuilder = this.nodeMap.get(json['$idref'].split("/")[0]);      // search for instanceBuilder
                if (instanceBuilder && !instanceBuilder.ancestor()) instanceBuilder.ancestor(this.findNode(instanceBuilder.ancestor._json));
                this.registerInstances(instanceBuilder);
                node = this.nodeMap.get(json['$idref']);   // search again for referenced object
                if (!node) throw new Error("Dejsonify Error: cannot resolve reference: " + json["$idref"]);
                return node;
            }
        }
    },

    jsonifyEvent: function(event){
        var owner = event.target.collection.isOwner();
        var colType = event.target.collection.getType();

        var node = event.target.node.$id;
        var col = event.target.collection.getName();
        var key = event.target.key;
        if (colType == "map" || colType == "set") key = this.getKeyHash(event.target.key);

        var type, value, oldValue;
        switch(event.type){
            case "change":
                type = "change";
                value = this.jsonifyValue(event.value, owner);
                oldValue = event.oldValueJson;
                break;
            case "add":
                type = colType == "list" ? "insert" : "change";
                value = this.jsonifyValue(event.value, owner);
                break;
            case "put":
                type = "change";
                value = this.jsonifyValue(event.value, owner);
                oldValue = event.oldValueJson;
                if (colType == "map") {
                    value = [this.jsonifyValue(event.target.key, false), value];
                    if (oldValue !== undefined) oldValue = [this.jsonifyValue(event.target.key, false), oldValue];
                }
                break;
            case "remove":
                type = "remove";
                oldValue = event.oldValueJson;
                if (colType == "map") oldValue = [this.jsonifyValue(event.target.key, false), oldValue];
                break;
        }

        var json = [type, node, col, key, value, oldValue];  // TODO: jsonify in readable json from the moment events are not directly shared anymore!
        return json;
    },

    dejsonifyEvent: function(json){
        var node = this.nodeMap.get(json[1]);
        var col = node.collections.get(json[2]);

        var type, key, value, oldValue;
        switch (col.getType()){
            case 'value':
                type = "change";
                value = this.dejsonify(json[4]);
                oldValue = this.dejsonify(json[5]);
                break;
            case 'map':
                if (json[0] == "change"){
                    type = "put";
                    key = this.dejsonify(json[4][0]);
                    value = this.dejsonify(json[4][1]);
                    oldValue = this.dejsonify(json[5] && json[5][1]);
                } else {
                    type = "remove";
                    key = this.dejsonify(json[5][0]);
                    oldValue = this.dejsonify(json[5][1]);
                }
                break;
            case 'set':
                if (json[0] == "change"){
                    type = "add";
                    key = value = this.dejsonify(json[4]);
                } else {
                    type = "remove";
                    key = oldValue = this.dejsonify(json[5]);
                }
                break;
            case 'list':
                type = json[0] == "change" ? "put" : json[0] == "insert" ? "add" : "remove";
                key = json[3];
                value = this.dejsonify(json[4]);
                oldValue = this.dejsonify(json[5]);
                break;
        }

        return new TreeEvent(type, col, key, value, oldValue);
    },

    jsonifyDocument : function() {
        return {
            "header": this.header,
            "body": this.jsonify()
        };
    },

    collectReferencedDescriptions : function(node, descriptions, descriptionsInOrder) {
        if(!descriptions) descriptions = new HashSet();
        if(!descriptionsInOrder) descriptionsInOrder = new List();
        var DescriptionRoot = require("./descriptionRoot.js");// put this here to solve problem with cyclic dependency

        var self = this;
        node.forEachMember(function(val, col) {
            if(val && val.isObservableTreeNode && val.root instanceof DescriptionRoot) {
                if(!descriptions.contains(val.root)) {
                    descriptions.add(val.root);
                    self.collectReferencedDescriptions(val.root.data, descriptions, descriptionsInOrder);
                    descriptionsInOrder.add(0, val.root);
                    console.log(val.root.assetId)
                    console.log(descriptionsInOrder.toArray().map(function(root) { return root.assetId;}))
                }
            }
            if(val && val.isObservableTreeNode && col.isOwner) {
                self.collectReferencedDescriptions(val, descriptions, descriptionsInOrder);
            }
        });
        return descriptionsInOrder;
    },

    jsonifyWithDependencies : function() {
        var descriptions = this.collectReferencedDescriptions(this.data);
        return [this.jsonifyDocument()].concat(descriptions.map(function(idx, description) { return description.jsonifyDocument(); }).toArray());
    }
};

module.exports = JsonParser;
